import React, { Component } from "react";
import Aux from "./../../Auxiliary/Auxiliary";
import Questions from "./../Questions/Questions";
import styles from "./GetAllQuestions.module.css";
import axios from "./../../../axios-questions";
import Spinner from "./../../Spinner/Spinner";
// import Winner from "./../../Winner/Winner";
import Modal from "../../Modal/Modal";
import { Link } from "react-router-dom";

class GetAllQuestions extends Component {
  state = {
    questions: null,
    loading: true,
    score: 0,
    won: false,
  };
  componentDidMount() {
    const type = this.props.need;
    axios
      .get("/questions.json")
      .then((res) => {
        this.setState({
          questions: res.data["-MHcWMp2BxQE-KAr9kXU"][type],
          loading: false,
        });
        console.log("Successfully imported questions from firebase !!");
      })
      .catch((err) => {
        console.log(err);
        this.setState({ loading: false });
      });
  }
  onCorrectAnswerHandler = () => {
    const s = this.state.score;
    if (s + 5 >= 25) {
      this.setState({ won: true });
      this.props.cart(this.props.need);
    }
    this.setState({ score: s + 5 });
  };
  render() {
    return (
      <Aux>
        {this.state.loading ? (
          <Spinner />
        ) : (
          <Aux>
            {this.state.won ? (
              <Modal show={true}>
                <div className={styles.congrats}>Congratulations</div>
                <Link to="/" className={styles.home}>
                  Home
                </Link>
              </Modal>
            ) : null}

            <div className={styles.score}>Score: {this.state.score}</div>
            <p style={{ fontWeight: "bold" }}>
              Minimum score required : 25 (Each question carry 5 score)
            </p>
            <div className={styles.questions}>
              {this.state.questions.map((quest, i) => (
                <Questions
                  key={i}
                  question={quest.question}
                  correct={quest.answer}
                  score={this.onCorrectAnswerHandler}
                  qNo={i + 1}
                />
              ))}
            </div>
          </Aux>
        )}
      </Aux>
    );
  }
}

export default GetAllQuestions;
